import { render, staticRenderFns } from "./bettwasche.vue?vue&type=template&id=2f227cec&"
import script from "./bettwasche.vue?vue&type=script&lang=js&"
export * from "./bettwasche.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f227cec')) {
      api.createRecord('2f227cec', component.options)
    } else {
      api.reload('2f227cec', component.options)
    }
    module.hot.accept("./bettwasche.vue?vue&type=template&id=2f227cec&", function () {
      api.rerender('2f227cec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8p97YwfJSlMY0/JS/comp/bettwasche.vue"
export default component.exports